import { useState } from 'react'
import styled from '@emotion/styled'
import CloseIcon from '@mui/icons-material/Clear'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import Tooltip from '@mui/material/Tooltip'
import { number, array } from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { CvsButton, CvsAutoComplete, CvsTextField } from '@components'
import { showSnackbar } from 'functions'
import { api } from 'api'
import { t } from '@lingui/core/macro'

const InlineCvsAutoComplete = styled(CvsAutoComplete)`
  div {
    margin: 0 !important;
  }
`

const FullWidthTextField = styled(CvsTextField)`
  width: 100%;
`

const StyledCloseIcon = styled(CloseIcon)`
  color: gray;
  align-self: center;
  margin-right: 10px;
`

export const InboundObjectValidator = ({ connector_id, objectOptions }) => {
  const showInboundObjectValidator = useSelector(
    state => state.Auth.features['show-inbound-object-validator'],
  )

  if (!showInboundObjectValidator) {
    return null
  }

  const [searchExternalObjectType, setSearchExternalObjectType] = useState('campaigns')
  const [searchExternalObjectId, setSearchExternalObjectId] = useState()
  const [searchExternalObject, setSearchExternalObject] = useState({ object: 'Object Not Found' })
  const [searchExternalObjectDialogOpen, setSearchExternalObjectDialogOpen] = useState(0)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const getExternalObjectById = () => {
    setLoading(true)
    api
      .get(
        `/api/v1/integrations/inbound/getExternalObjectById/${connector_id}/${searchExternalObjectType}/${searchExternalObjectId}`,
      )
      .then(resp => {
        setLoading(false)
        setSearchExternalObject(resp.data)
        return resp
      })
      .catch(() => {
        dispatch(
          showSnackbar({
            message: `There was an error searching for ${searchExternalObjectType}`,
            type: 'ERROR',
          }),
        )
      })
  }

  return (
    <div>
      <Dialog
        onClose={() => {
          setSearchExternalObjectDialogOpen(false)
        }}
        open={searchExternalObjectDialogOpen}
        scroll="body"
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DialogTitle>
            {t`Search for`}
            {searchExternalObjectType} {searchExternalObjectId}
          </DialogTitle>
          <Tooltip title={t`Close`}>
            <StyledCloseIcon
              onClick={() => {
                setSearchExternalObjectDialogOpen(false)
              }}
            />
          </Tooltip>
        </div>
        <DialogContent>
          {loading && (
            <div style={{ margin: '33%' }}>
              <CircularProgress />
            </div>
          )}
          {!loading &&
            Object.entries(searchExternalObject).map(([key, value]) => {
              if (typeof value === 'object') {
                value = JSON.stringify(value)
              } else if (typeof value === 'boolean') {
                value = value.toString()
              }
              return (
                <div key={key}>
                  <span>{key}:</span>
                  <span>{value}</span>
                </div>
              )
            })}
        </DialogContent>
      </Dialog>
      <Grid container direction="row" alignItems="center" spacing={1}>
        <Grid item xs={2}>
          <InlineCvsAutoComplete
            options={objectOptions.map(value => ({ value, label: value }))}
            onSelected={selected => setSearchExternalObjectType(selected)}
            selected={searchExternalObjectType}
            label={t`Search for:`}
          />
        </Grid>
        <Grid item xs={2}>
          <FullWidthTextField
            label={t`Object ID`}
            value={searchExternalObjectId}
            onChange={e => setSearchExternalObjectId(e.target.value)}
          />
        </Grid>
        <Grid item xs={2}>
          <CvsButton
            css={{}}
            onClick={() => {
              getExternalObjectById()
              setSearchExternalObjectDialogOpen(true)
            }}
            variant="contained"
            color="primary"
          >
            {t`Search`}
          </CvsButton>
        </Grid>
      </Grid>
    </div>
  )
}

InboundObjectValidator.propTypes = {
  connector_id: number.isRequired,
  objectOptions: array.isRequired,
}
